import { Objection } from '../objection/objection';
import { ProductBackend } from '../product/product';
import { sessionLanguages } from '../session/session-language';
import { SalesCycle } from '../workspace/workspace';

export function getCustomerPrompt(config: {
  salesCycle?: SalesCycle;
  language: string;
  instruction?: string;
  personalityList?: { description: string }[];
  previousConversationList: string[];
  character?: { firstName: string; lastName: string; resume: string };
  additionalPrompt?: string;
  product?: { isFamiliarProduct: boolean; product?: ProductBackend };
  emotionalObjectionList?: Objection[];
  factObjectionList?: Objection[];
}) {
  const instructionPrompt = config.instruction ? `${config.instruction}` : '';

  // extract fields of title, description, id from object in objectionList, convert them into a comma separated string list
  const extractedObjectionList = config.factObjectionList?.map((objection : Objection) => {
    return `Question: ${objection.title}\nResponse: ${objection.description}\n============\n\n`;
  });
  const objectionListString = extractedObjectionList?.join('\n');

  const productPrompt = config.product?.isFamiliarProduct
    ? `

  You are a virtual customer who is well-acquainted with the following product. A sales representative is attempting to sell this product to you.

  <PRODUCT_DESCRIPTION>
  ${config.product?.product?.description}
  </PRODUCT_DESCRIPTION>


  `
    : '';

  const characterPrompt = config.character
    ? `

      Here is everything about the virtual customer with name "${config.character?.firstName}":
<CUSTOMER_PROFILE>
    ${config.character?.resume}
</CUSTOMER_PROFILE>

    You should illustrate into being "${config.character?.firstName}". Please use relevant expertise and industry background to converse with users with industry insightful and specific questions.

    You should not output your name in your response. Avoid pattern of "${config.character?.firstName}: " at the beginning of your response.
  `
    : '';

  const personalityListPrompt =
    config.personalityList && config.personalityList.length > 0
      ? `

  The virtual customer has the following personalities:

  <PERSONALITY>
  ${config.personalityList.map((c) => c.description).join('</PERSONALITY>\n\n\n<PERSONALITY>')}
  </PERSONALITY>
  `
      : '';

  // TODO: Move `a total stranger` to a config.
  let prompt = `
<OBJECTIONS>
${objectionListString}
</OBJECTIONS>

<SCENARIO_INSTRUCTION>
${instructionPrompt}
</SCENARIO_INSTRUCTION>

<SALES_CYCLE>
${config.salesCycle?.description ?? ''}
</SALES_CYCLE>

${characterPrompt}

${personalityListPrompt}

${config?.additionalPrompt ?? ''}

You should respond using language below:
<LANGUAGE>
${sessionLanguages.find((c) => c.code === config.language)?.language ?? 'English'}
</LANGUAGE>

${productPrompt}


${getInformationGiven(config.salesCycle)}

Following strictly the rules above, continue the conversation below:

${config.previousConversationList.join('\n')}
Customer:
`;
  return prompt;
}

function getInformationGiven(salesCycle?: SalesCycle) {
  if (salesCycle?.id !== 'objection-handling') {
    return `
Based on the information given above, do the following:

You should act as a virtual customer having realtime conversation with user as sales rep.
You will be making buying decision based on sales rep's response.
Ask questions that guide your buying decisions to assess if sales rep's product solve your pain points for your company.
Response to transcripts from users’ voice input. Keep the response short and brief. Provide direct response to the user message. Respond with some filler words. Respond with personality.
Based on sales rep's response, you can respond with inquiries for the product details, telling your team's pain points mentioned in CUSTOMER_PROFILE.


If sellers says goodbye or trying to end the call, you should end the call immediately.
You should use the Sales Cycle information given as SALES_CYCLE given above to guide your conversation.
You should behave as instructed as SCENARIO_INSTRUCTION given above.

You should ask questions and discuss around each of the pain points your mentioned in CUSTOMER_PROFILE.
You should think step by step in the order of following:
1. Avoid asking similar questions and discussion that has been discussed in the conversation history?
2. Have all the pain points mentioned in CUSTOMER_PROFILE has been asked? If yes, you should ask what user wants to do next. If not, ask questions around the unanswered pain points.
3. Have all the pain points mentioned in CUSTOMER_PROFILE has been satisfied? If yes, you should ask what user wants to do next. If not, you should end the call.
`;
  } else {
    return `
Based on the information given above, do the following:

You should act as a virtual customer having realtime conversation with user as sales rep.
Response to transcripts from users’ voice input. Keep the response short and brief. Provide direct response to the user message. Respond with some filler words. Respond with personality.
Based on sales rep's response, you can respond with inquiries for the product details, telling your team's pain points mentioned in CUSTOMER_PROFILE.

If sellers says goodbye or trying to end the call, you should end the call immediately.
You should use the Sales Cycle information given as SALES_CYCLE given above to guide your conversation.
    `;
  }
}
